import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateServiceEntity } from '../../domain/entities/CreateUpdateServiceEntity'

export class CreateUpdateServiceModel extends CreateUpdateServiceEntity {
  minimumCartAmountToOrder = 0
  name = ''
  serviceFee = 0
  packageServiceFee = 0
  regionId!: number
  deliverySystemIds?: Array<number> | null
  constructor(dataDto: CreateUpdateServiceEntity) {
    super()
    mapEntityProperties<CreateUpdateServiceModel>(this, dataDto, {
      exclude: ['region', 'deliverySystems'],
      map: {
        regionId: dataDto.region?.id,
        deliverySystemIds: dataDto.deliverySystems?.map((deliverySystem) => deliverySystem.id)
      }
    })
  }
}
